import { render, staticRenderFns } from "./exemple.vue?vue&type=template&id=71d1de7a&scoped=true"
import script from "./exemple.vue?vue&type=script&lang=js"
export * from "./exemple.vue?vue&type=script&lang=js"
import style0 from "./exemple.vue?vue&type=style&index=0&id=71d1de7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d1de7a",
  null
  
)

export default component.exports